module.exports = __webpack_public_path__ + "media/icons/tire@2x-7b60cb6f.png";